module.exports = __webpack_public_path__ + "img/logo.aa565ebd.png";